import config from '@/config'
import { device } from '@/utils/device.js'
import { getWxConfig } from '@/api/courseApi'
export function formatDate(time, fmt = "yyyy-MM-dd hh:mm") {
  if(!time) {
    return ""
  }
  let date = new Date(time)
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      (date.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  }
  let o = {
    "M+": date.getMonth() + 1,
    "d+": date.getDate(),
    "h+": date.getHours(),
    "m+": date.getMinutes(),
    "s+": date.getSeconds(),
  };
  for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      let str = o[k] + "";
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? str : ('00' + str).substr(str.length)
      );
    }
  }
  return fmt;
}

export function formatSeconds(time) {
  if (time === undefined || time === null || time === '' || time < 0) {
    return ''
  }
  let seconds = time % 60
  let minutes = Math.floor((time/60) % 60) 
  let hours = Math.floor(time/3600)
  return (hours > 9 ? hours: '0' + hours) + ':' + (minutes > 9 ? minutes: '0' + minutes) + ':' + (seconds > 9 ? seconds: '0' + seconds)
}

export function formateSeconds(endTime){
  let secondTime = parseInt(endTime)//将传入的秒的值转化为Number
  let min = 0// 初始化分
  let h =0// 初始化小时
  let result=''
  if(secondTime>60){//如果秒数大于60，将秒数转换成整数
    min=parseInt(secondTime/60)//获取分钟，除以60取整数，得到整数分钟
    secondTime=parseInt(secondTime%60)//获取秒数，秒数取佘，得到整数秒数
    if(min>60){//如果分钟大于60，将分钟转换成小时
      h=parseInt(min/60)//获取小时，获取分钟除以60，得到整数小时
      min=parseInt(min%60) //获取小时后取佘的分，获取分钟除以60取佘的分
    }
  }
  result=`${h.toString().padStart(2,'0')}:${min.toString().padStart(2,'0')}:${secondTime.toString().padStart(2,'0')}`
  return result
}
// 字数统计
export function wordCount(content) {
  let sLen = 0;
  let str = String(content);
  try {
    str = str.replace(/<[^>]+>/g, "");
    // 先将回车换行符做特殊处理
    str = str.replace(/(\r\n+|\s+)/g, "龘");
    // 处理英文字符数字，连续字母、数字、英文符号视为一个单词
    str = str.replace(/[\x00-\xff]/g, "m");
    // 合并字符m，连续字母、数字、英文符号视为一个单词
    str = str.replace(/m+/g, "*");
    // 去掉回车换行符
    str = str.replace(/龘+/g, "");
    // 返回字数
    sLen = str.length;
  } catch (e) {
    sLen = 0;
  }
  return sLen;
}

export const buildResourcePath = (src) => {
  if (!src) {
    return ''
  }
  var httpReg = /^(http|https)/;
  if (httpReg.test(src)) {
    src = src.replace("https://leicloud.ulearning.cn", config.RESOURCE_SERVER_HOST);
    src = src.replace("http://leicloud.qiniudn.com", config.RESOURCE_SERVER_HOST);
  } else {
    src = config.RESOURCE_SERVER_HOST + "/" + src;
  }
  return src;
}

export function getUrlParam(name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return decodeURI(r[2]);
  return null;
}

export function getHtmlText(content) {
  if (content) {
    var temp = document.createElement("div");
    temp.innerHTML = content;
    var output = temp.innerText || temp.textContent;
    temp = null;
    return output.substring(0, 200);
  } else {
    return "";
  }
}

export function buildUrlProtocol (url) {
  var httpReg = /^(http|https)/
  if (!httpReg.test(url)) {
    url = 'https://' + url
  }
  return url
}

export function wxLogin() {
  let redirect_uri = encodeURIComponent(`https://www${config.UMOOC_COOKIE_DOMAIN}/r/wx.html`)
  if (!device.isMobile) {
    window.location.href =
      "https://open.weixin.qq.com/connect/qrconnect?lang=zh_CN" +
      "&appid=" +
      config.WXPCLOGINAPPID +
      "&redirect_uri=" +
      redirect_uri +
      "&response_type=code&scope=snsapi_login&state=STATE#wechat_redirect";
  }

  if (device.platform.weixin) {
    let url = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
      config.WXGZHAPPID +
      "&redirect_uri=" +
      redirect_uri +
      "&response_type=code&scope=snsapi_userinfo&state=1#wechat_redirect"
    window.location.href = url
  }
}

export function welinkLogin() {
  window.location.href =
    "index.html#/welinkCode?isLogin=1";
}

//保留n位小数
export function handleNum(num, precision = 1, method = "round") {
  const powers = Math.pow(10, precision)
  return /\./g.test(num) ? Math[method](num * powers) / powers : num
}

// 禁止缩放
export function disableZoom() {
  try {
    // 禁止双击放大
    document.addEventListener('touchstart', (e) => {
      if (e.touches.length > 1) {
        e.preventDefault()
      }
    })
    let lastTocuchEnd = 0;
    document.addEventListener('touchend', (e) => {
      const now = new Date().getTime()
      if (now - lastTocuchEnd <= 300) {
        e.preventDefault()
      }
      lastTocuchEnd = now
    }, false);
    // 禁止多手指手势
    document.addEventListener('gesturestart', (e) => {
      e.preventDefault()
    })
  } catch (e) {
    console.log(e)
  }
}

export function setWxConfig() {
  let data = {
    url: location.href.split("#")[0],
  }
  getWxConfig(data).then(res => {
    const result = res
    wx.config({
      debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
      appId: result.appId, // 必填，公众号的唯一标识
      timestamp: result.timestamp, // 必填，生成签名的时间戳
      nonceStr: result.nonceStr, // 必填，生成签名的随机串
      signature: result.signature, // 必填，签名
      jsApiList: [
        "hideOptionMenu",
        "hideAllNonBaseMenuItem"
      ] // 必填，需要使用的JS接口列表
    });
    wx.ready(function () {
      wx.checkJsApi({
        jsApiList: [
          "hideOptionMenu",
          "hideAllNonBaseMenuItem"
        ], // 需要检测的JS接口列表，所有JS接口列表见附录2,
        success: function (res) {

        },
      });
      wx.hideOptionMenu();
      wx.hideAllNonBaseMenuItem();
    });
  })
}